const GLOBAL_PERMISSIONS = {
  ACCESS_ALL_COMPANIES: 'ACCESS_ALL_COMPANIES',
};

const COMPANY_PERMISSIONS = {
  COMPANY_CREATE: 'COMPANY_CREATE',
  COMPANY_ASSIGN: 'COMPANY_ASSIGN',
  COMPANY_CONNECTION_SETTINGS_READ: 'COMPANY_CONNECTION_SETTINGS_READ',
  COMPANY_CONNECTION_SETTINGS_EDIT: 'COMPANY_CONNECTION_SETTINGS_EDIT',
  COMPANY_GENERAL_SETTINGS_READ: 'COMPANY_GENERAL_SETTINGS_READ',
  COMPANY_GENERAL_SETTINGS_EDIT: 'COMPANY_GENERAL_SETTINGS_EDIT',
  COMPANY_GENERAL_SETTINGS_EDIT_PACKAGES:
    'COMPANY_GENERAL_SETTINGS_EDIT_PACKAGES',
  COMPANY_MEMBERS_MANAGE: 'COMPANY_MEMBERS_MANAGE',
  COMPANY_MEMBERS_SHARE: 'COMPANY_MEMBERS_SHARE',
  COMPANY_MEMBERS_BULK_INVITE: 'COMPANY_MEMBERS_BULK_INVITE',
  COMPANY_GLOBAL_MEMBERS_READ: 'COMPANY_GLOBAL_MEMBERS_READ',
  COMPANY_GLOBAL_MEMBERS_EDIT: 'COMPANY_GLOBAL_MEMBERS_EDIT',
  COMPANY_INTERNAL_MEMBERS_READ: 'COMPANY_INTERNAL_MEMBERS_READ',
  COMPANY_INTERNAL_MEMBERS_EDIT: 'COMPANY_INTERNAL_MEMBERS_EDIT',
  COMPANY_CLIENT_MEMBERS_READ: 'COMPANY_CLIENT_MEMBERS_READ',
  COMPANY_CLIENT_MEMBERS_EDIT: 'COMPANY_CLIENT_MEMBERS_EDIT',
  COMPANY_CHANGE_STATUS: 'COMPANY_CHANGE_STATUS',
  COMPANY_PLATFORM_FEATURES_EDIT: 'COMPANY_PLATFORM_FEATURES_EDIT',
};

const CONVERSATION_PERMISSIONS = {
  CONVERSATION_MANAGE: 'CONVERSATION_MANAGE',
};

const FLOW_PERMISSIONS = {
  FLOW_LIST: 'FLOW_LIST',
  FLOW_EDIT: 'FLOW_EDIT',
  FLOW_REVISION_UPDATE: 'FLOW_REVISION_UPDATE',
  FLOW_REVISION_DELETE: 'FLOW_REVISION_DELETE',
  SUBFLOW_TEMPLATES_LIST: 'SUBFLOW_TEMPLATES_LIST',
  SUBFLOW_TEMPLATES_CREATE: 'SUBFLOW_TEMPLATES_CREATE',
  SUBFLOW_TEMPLATES_DELETE: 'SUBFLOW_TEMPLATES_DELETE',
  SUBFLOW_TEMPLATES_INFO: 'SUBFLOW_TEMPLATES_INFO',
};

const AGENT_PERMISSIONS = {
  AGENT_LIST: 'AGENT_LIST',
  AGENT_CREATE: 'AGENT_CREATE',
  AGENT_EDIT: 'AGENT_EDIT',
  AGENT_REMOVE: 'AGENT_REMOVE',
};

const INBOX_PERMISSIONS = {
  INBOX_LIST: 'INBOX_LIST',
  INBOX_CREATE: 'INBOX_CREATE',
  INBOX_EDIT: 'INBOX_EDIT',
  INBOX_REMOVE: 'INBOX_REMOVE',
};

const LABEL_PERMISSIONS = {
  LABEL_LIST: 'LABEL_LIST',
  LABEL_CREATE: 'LABEL_CREATE',
  LABEL_EDIT: 'LABEL_EDIT',
  LABEL_REMOVE: 'LABEL_REMOVE',
};

const CANNED_RESPONSE_PERMISSIONS = {
  CANNED_RESPONSE_LIST: 'CANNED_RESPONSE_LIST',
  CANNED_RESPONSE_CREATE: 'CANNED_RESPONSE_CREATE',
  CANNED_RESPONSE_EDIT: 'CANNED_RESPONSE_EDIT',
  CANNED_RESPONSE_REMOVE: 'CANNED_RESPONSE_REMOVE',
};

const FACEBOOK_PERMISSIONS = {
  FACEBOOK_LIST: 'FACEBOOK_LIST',
  FACEBOOK_CREATE: 'FACEBOOK_CREATE',
  FACEBOOK_EDIT: 'FACEBOOK_EDIT',
  FACEBOOK_REMOVE: 'FACEBOOK_REMOVE',
};

const WEBCLIENT_PERMISSIONS = {
  WEBCLIENT_CREATE: 'WEBCLIENT_CREATE',
  WEBCLIENT_CONFIG_LIST: 'WEBCLIENT_CONFIG_LIST',
  WEBCLIENT_CONFIG_CREATE: 'WEBCLIENT_CONFIG_CREATE',
  WEBCLIENT_CONFIG_EDIT: 'WEBCLIENT_CONFIG_EDIT',
  WEBCLIENT_CONFIG_REMOVE: 'WEBCLIENT_CONFIG_REMOVE',
  WEBCLIENT_WHITELIST_ADD: 'WEBCLIENT_WHITELIST_ADD',
  WEBCLIENT_WHITELIST_REMOVE: 'WEBCLIENT_WHITELIST_REMOVE',
  WEBCLIENT_ACCESS_LIST: 'WEBCLIENT_ACCESS_LIST',
  // * Grants access to Chat Preview only - does not unlock Configuration or Styling
  WEBCLIENT_PREVIEW: 'WEBCLIENT_PREVIEW',
};

const PROFILE_PERMISSIONS = {
  PROFILE_READ: 'PROFILE_READ',
  PROFILE_EDIT: 'PROFILE_EDIT',
};

const ROLE_PERMISSIONS = {
  LIST_ROLES: 'LIST_ROLES',
  EDIT_ROLES: 'EDIT_ROLES',
};

const LINK_PERMISSIONS = {
  MANAGE_LINKS: 'LINK_MANAGE',
};

const EXPORT_PERMISSIONS = {
  EXPORT_LIST: 'EXPORT_LIST',
  EXPORT_DOWNLOAD: 'EXPORT_DOWNLOAD',
  EXPORT_DELETE: 'EXPORT_DELETE',
  EXPORT_CONFIG_LIST: 'EXPORT_CONFIG_LIST',
};

const DATA_SOURCE_PERMISSIONS = {
  DATA_SOURCE_LIST: 'DATA_SOURCE_LIST',
  DATA_SOURCE_DOWNLOAD: 'DATA_SOURCE_DOWNLOAD',
  DATA_SOURCE_DELETE: 'DATA_SOURCE_DELETE',
  DATA_SOURCE_DELETE_FROM_TRAIN_FOLDER: 'DATA_SOURCE_DELETE_FROM_TRAIN_FOLDER',
  DATA_SOURCE_UPLOAD: 'DATA_SOURCE_UPLOAD',
  DATA_SOURCE_EDIT: 'DATA_SOURCE_EDIT',
  DATA_SOURCE_MANUAL_TRAINING: 'DATA_SOURCE_MANUAL_TRAINING',
  DATA_SOURCE_INFO: 'DATA_SOURCE_INFO',
  DATA_SOURCE_SHARE: 'DATA_SOURCE_SHARE',
  DATA_SOURCE_SCRAPE_WEBSITE: 'DATA_SOURCE_SCRAPE_WEBSITE',
  DATA_SOURCE_CREATE_SUBFOLDER: 'DATA_SOURCE_CREATE_SUBFOLDER',
  DATA_SOURCE_DELETE_SUBFOLDER: 'DATA_SOURCE_DELETE_SUBFOLDER',
  DATA_SOURCE_MOVE_FILE: 'DATA_SOURCE_MOVE_FILE',
  ARTICLE_ARCHITECT_VIEW: 'ARTICLE_ARCHITECT_VIEW',
  ARTICLE_ARCHITECT_GENERATE: 'ARTICLE_ARCHITECT_GENERATE',
  ARTICLE_ARCHITECT_EDIT: 'ARTICLE_ARCHITECT_EDIT',
  ARTICLE_ARCHITECT_DELETE: 'ARTICLE_ARCHITECT_DELETE',
};

const GDPR_PERMISSIONS = {
  GDPR_LIST: 'GDPR_LIST',
  GDPR_DOWNLOAD: 'GDPR_DOWNLOAD',
  GDPR_DELETE: 'GDPR_DELETE',
  GDPR_SEND: 'GDPR_SEND',
};

const APPLICATION_PERMISSIONS = {
  APPLICATION_LIST_SETTINGS: 'APPLICATION_LIST_SETTINGS',
  APPLICATION_UPDATE_SETTINGS: 'APPLICATION_UPDATE_SETTINGS',
  APPLICATION_EXPORT_UPDATE_SETTINGS: 'APPLICATION_EXPORT_UPDATE_SETTINGS',
  APPLICATION_EXPORT_LIST_SETTINGS: 'APPLICATION_EXPORT_LIST_SETTINGS',
};

const LOGS_PERMISSIONS = {
  VIEW_LOGS: 'VIEW_LOGS',
  VIEW_GDPR_LOGS: 'VIEW_GDPR_LOGS',
  VIEW_CONVERSATION_LOGS: 'VIEW_CONVERSATION_LOGS',
  VIEW_SETTINGS_LOGS: 'VIEW_SETTINGS_LOGS',
  VIEW_INTEGRATION_LOGS: 'VIEW_INTEGRATION_LOGS',
  VIEW_FLOW_LOGS: 'VIEW_FLOW_LOGS',
};

const REPORTING_PERMISSIONS = {
  REPORTING_VIEW: 'REPORTING_VIEW',
  REPORTING_PLATFORM_METRICS_VIEW: 'REPORTING_PLATFORM_METRICS_VIEW',
};

const TRAINER_AI_PERMISSIONS = {
  TRAINER_AI_VIEW: 'TRAINER_AI_VIEW',
  TRAINER_AI_CHECKLIST: 'TRAINER_AI_CHECKLIST',
  TRAINER_AI_EDIT: 'TRAINER_AI_EDIT',
  TRAINER_AI_ONLY_FACTCHECK_VIEW: 'TRAINER_AI_ONLY_FACTCHECK_VIEW',
};

const DASHBOARD_PERMISSIONS = {
  DASHBOARD_VIEW: 'DASHBOARD_VIEW',
};

const INTEGRATIONS_PERMISSIONS = {
  INTEGRATIONS_VIEW: 'INTEGRATIONS_VIEW',
};

const TEST_ACCURACY_PERMISSIONS = {
  TEST_ACCURACY_EDIT: 'TEST_ACCURACY_EDIT',
  LANGSMITH: 'LANGSMITH',
};

const INVITE_EMAIL_TEMPLATE_PERMISSIONS = {
  INVITE_EMAIL_TEMPLATE_EDIT: 'INVITE_EMAIL_TEMPLATE_EDIT',
};

const PUBLIC_API_SETTINGS_PERMISSIONS = {
  PUBLIC_API_SETTINGS_EDIT: 'PUBLIC_API_SETTINGS_EDIT',
};

const TEMPLATE_RESPONSE_PERMISSIONS = {
  TEMPLATE_RESPONSE_LIST: 'TEMPLATE_RESPONSE_LIST',
  TEMPLATE_RESPONSE_CREATE: 'TEMPLATE_RESPONSE_CREATE',
  TEMPLATE_RESPONSE_EDIT: 'TEMPLATE_RESPONSE_EDIT',
  TEMPLATE_RESPONSE_DELETE: 'TEMPLATE_RESPONSE_DELETE',
};

const CONVERSATION_KEYWORDS_PERMISSIONS = {
  CONVERSATION_KEYWORDS_LIST: 'CONVERSATION_KEYWORDS_LIST',
  CONVERSATION_KEYWORDS_CREATE: 'CONVERSATION_KEYWORDS_CREATE',
  CONVERSATION_KEYWORDS_EDIT: 'CONVERSATION_KEYWORDS_EDIT',
  CONVERSATION_KEYWORDS_DELETE: 'CONVERSATION_KEYWORDS_DELETE',
};

const VOICE_AI_PERMISSIONS = {
  VOICE_AI_CONFIGURATION_FORM: 'VOICE_AI_CONFIGURATION_FORM',
  VOICE_AI_PREVIEW: 'VOICE_AI_PREVIEW',
  VOICE_STUDIO_MANAGE: 'VOICE_STUDIO_MANAGE',
};

const EMAIL_STUDIO_PERMISSIONS = {
  EMAIL_STUDIO_MANAGE: 'EMAIL_STUDIO_MANAGE',
};

const TICKET_DEFLECTION_PERMISSIONS = {
  TICKET_DEFLECTION_FEEDBACK: 'TICKET_DEFLECTION_FEEDBACK',
  TICKET_DEFLECTION_SUBMIT: 'TICKET_DEFLECTION_SUBMIT',
};

export const PERMISSIONS = {
  GLOBAL: GLOBAL_PERMISSIONS,
  COMPANY: COMPANY_PERMISSIONS,
  CONVERSATION: CONVERSATION_PERMISSIONS,
  FLOW: FLOW_PERMISSIONS,
  AGENT: AGENT_PERMISSIONS,
  ROLE: ROLE_PERMISSIONS,
  INBOX: INBOX_PERMISSIONS,
  LABEL: LABEL_PERMISSIONS,
  CANNED_RESPONSE: CANNED_RESPONSE_PERMISSIONS,
  FACEBOOK: FACEBOOK_PERMISSIONS,
  WEBCLIENT: WEBCLIENT_PERMISSIONS,
  PROFILE: PROFILE_PERMISSIONS,
  LINK: LINK_PERMISSIONS,
  DATA_SOURCE: DATA_SOURCE_PERMISSIONS,
  EXPORTS: EXPORT_PERMISSIONS,
  GDPR: GDPR_PERMISSIONS,
  APPLICATION: APPLICATION_PERMISSIONS,
  LOGS: LOGS_PERMISSIONS,
  REPORTING: REPORTING_PERMISSIONS,
  TRAINER_AI: TRAINER_AI_PERMISSIONS,
  DASHBOARD: DASHBOARD_PERMISSIONS,
  INTEGRATIONS: INTEGRATIONS_PERMISSIONS,
  TEST_ACCURACY: TEST_ACCURACY_PERMISSIONS,
  EMAIL_TEMPLATE: INVITE_EMAIL_TEMPLATE_PERMISSIONS,
  PUBLIC_API_SETTINGS: PUBLIC_API_SETTINGS_PERMISSIONS,
  TEMPLATE_RESPONSE: TEMPLATE_RESPONSE_PERMISSIONS,
  VOICE_AI: VOICE_AI_PERMISSIONS,
  EMAIL_STUDIO: EMAIL_STUDIO_PERMISSIONS,
  TICKET_DEFLECTION: TICKET_DEFLECTION_PERMISSIONS,
  CONVERSATION_KEYWORDS: CONVERSATION_KEYWORDS_PERMISSIONS,
};

export const ALL_PERMISSIONS = Object.values(PERMISSIONS).flatMap(
  Object.values,
);

export const PERMISSIONS_WITH_LABEL_KEY = [
  {
    label: 'permission.label.global',
    permissions: Object.values(PERMISSIONS.GLOBAL),
  },
  {
    label: 'permission.label.company',
    permissions: Object.values(PERMISSIONS.COMPANY),
  },
  {
    label: 'permission.label.conversation',
    permissions: Object.values(PERMISSIONS.CONVERSATION),
  },
  {
    label: 'permission.label.flow',
    permissions: Object.values(PERMISSIONS.FLOW),
  },
  {
    label: 'permission.label.agent',
    permissions: Object.values(PERMISSIONS.AGENT),
  },
  {
    label: 'permission.label.role',
    permissions: Object.values(PERMISSIONS.ROLE),
  },
  {
    label: 'permission.label.inbox',
    permissions: Object.values(PERMISSIONS.INBOX),
  },
  {
    label: 'permission.label.label',
    permissions: Object.values(PERMISSIONS.LABEL),
  },
  {
    label: 'permission.label.canned_response',
    permissions: Object.values(PERMISSIONS.CANNED_RESPONSE),
  },
  {
    label: 'permission.label.facebook',
    permissions: Object.values(PERMISSIONS.FACEBOOK),
  },
  {
    label: 'permission.label.webclient',
    permissions: Object.values(PERMISSIONS.WEBCLIENT),
  },
  {
    label: 'permission.label.profile',
    permissions: Object.values(PERMISSIONS.PROFILE),
  },
  {
    label: 'permission.label.link',
    permissions: Object.values(PERMISSIONS.LINK),
  },
  {
    label: 'permission.label.data_source',
    permissions: Object.values(PERMISSIONS.DATA_SOURCE),
  },
  {
    label: 'permission.label.exports',
    permissions: Object.values(PERMISSIONS.EXPORTS),
  },
  {
    label: 'permission.label.gdpr',
    permissions: Object.values(PERMISSIONS.GDPR),
  },
  {
    label: 'permission.label.application',
    permissions: Object.values(PERMISSIONS.APPLICATION),
  },
  {
    label: 'permission.label.logs',
    permissions: Object.values(PERMISSIONS.LOGS),
  },
  {
    label: 'permission.label.reporting',
    permissions: Object.values(PERMISSIONS.REPORTING),
  },
  {
    label: 'permission.label.trainer-ai',
    permissions: Object.values(PERMISSIONS.TRAINER_AI),
  },
  {
    label: 'permission.label.dashboard',
    permissions: Object.values(PERMISSIONS.DASHBOARD),
  },
  {
    label: 'permission.label.integrations',
    permissions: Object.values(PERMISSIONS.INTEGRATIONS),
  },
  {
    label: 'permission.label.test-accuracy',
    permissions: Object.values(PERMISSIONS.TEST_ACCURACY),
  },
  {
    label: 'permission.label.email-template',
    permissions: Object.values(PERMISSIONS.EMAIL_TEMPLATE),
  },
  {
    label: 'permission.label.public-api-settings',
    permissions: Object.values(PERMISSIONS.PUBLIC_API_SETTINGS),
  },
  {
    label: 'permission.label.template-response',
    permissions: Object.values(PERMISSIONS.TEMPLATE_RESPONSE),
  },
  {
    label: 'permission.label.voice-ai',
    permissions: Object.values(PERMISSIONS.VOICE_AI),
  },
  {
    label: 'permission.label.email-studio',
    permissions: Object.values(PERMISSIONS.EMAIL_STUDIO),
  },
  {
    label: 'permission.label.ticket-deflection',
    permissions: Object.values(PERMISSIONS.TICKET_DEFLECTION),
  },
  {
    label: 'permission.label.conversation-keywords',
    permissions: Object.values(PERMISSIONS.CONVERSATION_KEYWORDS),
  },
];

export const DEFAULT_ROLES = {
  SUPER_ADMIN_ROLE: 'superAdmin',
  AI_TRAINER_ROLE: 'aiTrainer',
  CONTRIBUTOR_ROLE: 'contributor',
  REVIEWER_ROLE: 'reviewer',
  DATA_ANALYST_ROLE: 'dataAnalyst',
  LIVE_CHAT_AGENT_ROLE: 'liveChatAgent',
  MANAGER_ROLE: 'manager',
} as const;

export const ROLE_LABELS = {
  superAdmin: 'roles-settings.role-super-admin',
  aiTrainer: 'roles-settings.role-ai-trainer',
  contributor: 'roles-settings.role-contributor',
  reviewer: 'roles-settings.role-reviewer',
  dataAnalyst: 'roles-settings.role-data-analyst',
  liveChatAgent: 'roles-settings.role-live-chat-agent',
  manager: 'roles-settings.role-manager',
} as const;

const BASE_PERMISSIONS = [
  PERMISSIONS.PROFILE.PROFILE_READ,
  PERMISSIONS.PROFILE.PROFILE_EDIT,
];

export const ROLE_SUPER_ADMIN_PERMISSIONS = [...ALL_PERMISSIONS];

// * Maximum permission set for client roles
// * Clients are barred from the Settings page, which is gated to superadmins only.
// * The A.I. Trainer manages the client-type members of its own company on the
// * stand-alone Users page instead. It holds no log permission and sees member
// * activity on the Activity tab of the Users page.
export const ROLE_AI_TRAINER_PERMISSIONS = [
  ...BASE_PERMISSIONS,
  // * A.I. Dashboard
  PERMISSIONS.DASHBOARD.DASHBOARD_VIEW,
  // * Train A.I. Studio
  ...Object.values(PERMISSIONS.TRAINER_AI),
  ...Object.values(PERMISSIONS.TEMPLATE_RESPONSE),
  // * A.I. Knowledge Hub
  ...Object.values(PERMISSIONS.DATA_SOURCE),
  // * Integrations
  PERMISSIONS.INTEGRATIONS.INTEGRATIONS_VIEW,
  // * Chat Preview + Styling + Configuration
  ...Object.values(PERMISSIONS.WEBCLIENT),
  // * Export Center
  PERMISSIONS.EXPORTS.EXPORT_LIST,
  PERMISSIONS.EXPORTS.EXPORT_DOWNLOAD,
  // * Users
  PERMISSIONS.COMPANY.COMPANY_MEMBERS_MANAGE,
  PERMISSIONS.COMPANY.COMPANY_CLIENT_MEMBERS_READ,
  PERMISSIONS.COMPANY.COMPANY_CLIENT_MEMBERS_EDIT,
];

export const ROLE_CONTRIBUTOR_PERMISSIONS = [
  ...BASE_PERMISSIONS,
  // * Chat Preview
  PERMISSIONS.WEBCLIENT.WEBCLIENT_PREVIEW,
];

export const ROLE_REVIEWER_PERMISSIONS = [
  ...BASE_PERMISSIONS,
  // * Train A.I. Studio
  ...Object.values(PERMISSIONS.TRAINER_AI),
  ...Object.values(PERMISSIONS.TEMPLATE_RESPONSE),
  // * Data source: delete from train folder (matching old trainerAI scope)
  PERMISSIONS.DATA_SOURCE.DATA_SOURCE_DELETE_FROM_TRAIN_FOLDER,
];

export const ROLE_DATA_ANALYST_PERMISSIONS = [
  ...BASE_PERMISSIONS,
  // * A.I. Dashboard (view only - no settings edit)
  PERMISSIONS.DASHBOARD.DASHBOARD_VIEW,
  // * Export Center (no delete)
  PERMISSIONS.EXPORTS.EXPORT_LIST,
  PERMISSIONS.EXPORTS.EXPORT_DOWNLOAD,
  PERMISSIONS.EXPORTS.EXPORT_CONFIG_LIST,
];

export const ROLE_LIVE_CHAT_AGENT_PERMISSIONS = [
  ...BASE_PERMISSIONS,
  // * Live Chat + Chat Preview
  PERMISSIONS.WEBCLIENT.WEBCLIENT_PREVIEW,
  PERMISSIONS.CONVERSATION.CONVERSATION_MANAGE,
  PERMISSIONS.AGENT.AGENT_LIST,
  PERMISSIONS.INBOX.INBOX_LIST,
  PERMISSIONS.LABEL.LABEL_LIST,
  PERMISSIONS.CANNED_RESPONSE.CANNED_RESPONSE_LIST,
];

export const ROLE_MANAGER_PERMISSIONS = [
  ...BASE_PERMISSIONS,
  // * A.I. Dashboard
  PERMISSIONS.DASHBOARD.DASHBOARD_VIEW,
];
